import { render } from "./TheSummary.vue?vue&type=template&id=3d1da4f1"
import script from "./TheSummary.vue?vue&type=script&lang=js"
export * from "./TheSummary.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__